<template>
    <div class="card w-100">
        <div class="card-body d-flex flex-column">
            <accent-box :title="$t('common.travelAdvisor.yourAgent')" class="managed-trip-user flex-grow-1">
                <div class="row">
                    <div class="managed-trip-user-contact col-md">
                        <div class="lead">{{user.fullName}}</div>
                        <div>
                            <font-awesome-icon :icon="['fal', 'square-envelope']" class="fa-lg text-dark me-1"/>
                            <span>
                                <a :href="`mailto:${user.email}`" class="ps-1">{{user.email}}</a>
                            </span>
                        </div>
                        <div>
                            <font-awesome-icon :icon="['fal', 'square-phone']" class="fa-lg text-dark me-1"/>
                            {{user.phone}}
                        </div>
                    </div>
                </div>
            </accent-box>
        </div>
    </div>
</template>

<script>
import AccentBox from "@/components/common/AccentBox";
export default {
    name: 'ManagedTripUser',
    components: {AccentBox},
    props: {
        user: {
            type: Object,
            required: true
        }
    }
};
</script>